"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneFromTemplateArtifact = void 0;
const uuid_1 = require("uuid");
const cloneUtils_1 = require("../cloneUtils");
const node_1 = require("./node");
const cloneConfig = ({ config, cloneMap: _unusedCloneMap, }) => {
    const { operationDescription, tapeDescription, createServicerReport, fundingSubmissionArtifactSlug, extendedResponseTapeUploads, receivableResponseTapeArtifactSlug, cashBalancesFeedContextArtifactSlug, cashResponseTapeArtifactSlug, } = config;
    return {
        operationDescription,
        tapeDescription,
        createServicerReport,
        fundingSubmissionArtifactSlug,
        extendedResponseTapeUploads,
        receivableResponseTapeArtifactSlug,
        cashBalancesFeedContextArtifactSlug,
        cashResponseTapeArtifactSlug,
    };
};
const cloneFromTemplateArtifact = ({ artifactToClone, newArtifactDocumentId, cloneMap, }) => {
    const configuration = cloneConfig({
        config: artifactToClone.configuration,
        cloneMap,
    });
    return {
        artifactSlug: artifactToClone.artifactSlug,
        artifactDocumentId: newArtifactDocumentId,
        creditFacilitySlug: (0, cloneUtils_1.getClonedSlug)(artifactToClone.creditFacilitySlug, cloneMap),
        loanProductSlug: (0, cloneUtils_1.getClonedSlug)(artifactToClone.loanProductSlug, cloneMap),
        externalFilename: null,
        id: (0, uuid_1.v4)(),
        type: node_1.artifactType,
        configuration,
    };
};
exports.cloneFromTemplateArtifact = cloneFromTemplateArtifact;
//# sourceMappingURL=clone.js.map